// Type for AssetYaml GraphQL type
export interface AssetYamlType {
  id: string;
  yamlId?: string;
  title?: string;
  description?: string;
  fileName?: string;
  url?: string;
  contentType?: string;
  width?: number;
  height?: number;
  size?: number;
  dominantColor?: string;
  imgix?: any;
}

export default class Asset {
  id: string;
  yamlId?: string;
  title?: string;
  description?: string;
  fileName?: string;
  url?: string;
  contentType?: string;
  width?: number;
  height?: number;
  size?: number;
  dominantColor?: string;
  imgix?: any;

  constructor(asset: AssetYamlType) {
    this.id = asset.id;
    this.yamlId = asset.yamlId;
    this.title = asset.title;
    this.description = asset.description;
    this.fileName = asset.fileName;
    this.url = asset.url;
    this.contentType = asset.contentType;
    this.width = asset.width;
    this.height = asset.height;
    this.size = asset.size;
    this.dominantColor = asset.dominantColor;
    this.imgix = {
      url: (params: Record<string, string | number | boolean> = {}) => {
        return this.getImgixUrl(params);
      },
    };
  }

  get isImage(): boolean {
    return this.contentType?.startsWith("image/") || false;
  }

  get isVideo(): boolean {
    return this.contentType?.startsWith("video/") || false;
  }

  private getImgixUrl(
    params: Record<string, string | number | boolean> = {}
  ): string | null {
    // Only process images from resources directory
    if (!this.url || !this.url.startsWith("~/resources/") || !this.isImage) {
      return null;
    }

    // Convert ~/resources/ path to imgix URL
    const resourcePath = this.url.replace(/^~\/resources\//, "");
    const baseUrl = `https://unprinted.imgix.net/${resourcePath}`;

    const searchParams = new URLSearchParams();

    // Add default parameters
    searchParams.append("auto", "format,compress");

    // Add custom parameters
    Object.entries(params).forEach(([key, value]) => {
      searchParams.append(key, value.toString());
    });

    return `${baseUrl}?${searchParams.toString()}`;
  }
}
